var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0005 0.806641C13.4146 0.806678 13.7503 1.14261 13.7505 1.55664V10.25C13.7505 11.3546 14.6459 12.25 15.7505 12.25H24.4429C24.8571 12.25 25.1929 12.5858 25.1929 13C25.1928 13.4141 24.857 13.75 24.4429 13.75H15.7505C14.6459 13.75 13.7505 14.6454 13.7505 15.75V24.4424C13.7505 24.8566 13.4147 25.1923 13.0005 25.1924C12.5863 25.1924 12.2505 24.8566 12.2505 24.4424V15.75C12.2505 14.6454 11.3551 13.75 10.2505 13.75H1.55713C1.14298 13.75 0.807227 13.4141 0.807129 13C0.807129 12.5858 1.14292 12.25 1.55713 12.25H10.2505C11.3551 12.25 12.2505 11.3546 12.2505 10.25V1.55664C12.2507 1.14259 12.5864 0.806641 13.0005 0.806641Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/PlusIcon.659c8dc2034e6f42c168a5844112e062.svg";
export { ForwardRef as ReactComponent };